module.exports = __webpack_public_path__ + "img/partner-3-light.b1634623.png";